import React from 'react';
import { PencilIcon } from 'lucide-react';
import { ConnectionPageLayout } from '../../components/connections/ConnectionPageLayout';
import { FilterSection } from '../../components/UI/FilterSidebar';
import { OpportunityItem } from '../../components/connections/OpportunityPreviewCard';
import { useDarkClasses } from '../../hooks/useDarkClasses';
import { useRoleTheme } from '../../hooks/useRoleTheme';
const ConnectWithEditors = () => {
  const dk = useDarkClasses();
  const rt = useRoleTheme();
  // Filters
  const filterSections: FilterSection[] = [{
    id: 'sort',
    title: 'Sort By',
    type: 'radio',
    options: [{
      value: 'relevance',
      label: 'Relevance'
    }, {
      value: 'rating-desc',
      label: 'Highest Rated'
    }],
    value: 'relevance',
    onChange: () => {}
  }, {
    id: 'availability',
    title: 'Availability',
    type: 'checkbox',
    options: [{
      value: 'open',
      label: 'Available Now'
    }, {
      value: 'booking',
      label: 'Booking for Q3'
    }],
    value: [],
    onChange: () => {}
  }, {
    id: 'editingType',
    title: 'Editing Type',
    type: 'checkbox',
    options: [{
      value: 'dev',
      label: 'Developmental'
    }, {
      value: 'copy',
      label: 'Copy Editing'
    }, {
      value: 'line',
      label: 'Line Editing'
    }, {
      value: 'proof',
      label: 'Proofreading'
    }],
    value: [],
    onChange: () => {}
  }];
  // Opportunities
  const opportunities: OpportunityItem[] = [{
    id: '1',
    title: 'Developmental Edit for Sci-Fi Novel',
    poster: 'Alex Zhang',
    deadline: '2023-11-25',
    type: 'Fixed Price',
    description: 'Looking for a developmental editor for a 90k word space opera. Focus on pacing and world-building.'
  }, {
    id: '2',
    title: 'Proofreading for Romance Series',
    poster: 'Elena Richards',
    deadline: '2023-12-05',
    type: 'Per Word',
    description: 'Need a proofreader for the final book in a 3-part contemporary romance series.'
  }];
  const formContent = <form className="space-y-6" data-id="element-13107" data-mp="2kt6530s3qfr">
      <div data-id="element-13108" data-mp="2n717bvgl2nb">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-13109" data-mp="31383vblps11c">
          Manuscript Title
        </label>
        <input type="text" className={`mt-1 block w-full rounded-md border shadow-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.inputOnCard}`} data-id="element-13110" data-mp="3619oi0ysg8ex" />
      </div>
      <div data-id="element-13111" data-mp="3g0inj88igd85">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-13112" data-mp="3g10k65z34tgl">
          Genre
        </label>
        <select className={`mt-1 block w-full rounded-md border shadow-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.inputOnCard}`} data-id="element-13113" data-mp="qaf1tghxznj0">
          <option data-id="element-13114" data-mp="2fsbzdlv04zv3">Select a genre</option>
          <option data-id="element-13115" data-mp="2fr9bznww1fjx">Romance</option>
          <option data-id="element-13116" data-mp="2at7rqznq7a6v">Mystery</option>
          <option data-id="element-13117" data-mp="2au0rvhs6j1g1">Fantasy</option>
          <option data-id="element-13118" data-mp="2av2b49jcmu8u">Science Fiction</option>
        </select>
      </div>
      <div data-id="element-13119" data-mp="260y2zmyckg66">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-13120" data-mp="260o9vqi09sw9">
          Word Count
        </label>
        <input type="number" className={`mt-1 block w-full rounded-md border shadow-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.inputOnCard}`} data-id="element-13121" data-mp="21120js5aswsq" />
      </div>
      <div data-id="element-13122" data-mp="1s4ue8968t013">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-13123" data-mp="1n3dg2lf57ro7">
          Type of Editing Needed
        </label>
        <select className={`mt-1 block w-full rounded-md border shadow-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.inputOnCard}`} data-id="element-13124" data-mp="1i53ik45y4ezf">
          <option data-id="element-13125" data-mp="3cibgw5t4r8pt">Select editing type</option>
          <option data-id="element-13126" data-mp="3cjmm8a284oj1">Developmental Editing</option>
          <option data-id="element-13127" data-mp="2a4x5tn0tvafh">Copy Editing</option>
          <option data-id="element-13128" data-mp="2a5yhntpo40y9">Line Editing</option>
          <option data-id="element-13129" data-mp="2a2srsc97sv1h">Proofreading</option>
        </select>
      </div>
      <div data-id="element-13130" data-mp="2e5gyoeedbrvt">
        <label className={`block text-sm font-medium ${dk.textSecondary}`} data-id="element-13131" data-mp="2e5yvbc4y0849">
          Project Description
        </label>
        <textarea rows={4} className={`mt-1 block w-full rounded-md border shadow-sm focus:outline-none focus:ring-2 px-3 py-2 ${rt.inputFocus} ${dk.inputOnCard}`} placeholder="Tell us about your project and what you're looking for in an editor..." data-id="element-13132" data-mp="208tr7hoshjbn" />
      </div>
      <div className="flex justify-end" data-id="element-13133" data-mp="1v9qz0xtwr7l3">
        <button type="submit" className={`px-4 py-2 rounded-md transition-colors text-white ${rt.primaryButton}`} data-id="element-13134" data-mp="1hgrh6p6nl1ad">
          Submit Request
        </button>
      </div>
    </form>;
  return <ConnectionPageLayout title="Connect with Editors" subtitle="Start your editing journey by connecting with our professional editors" icon={<PencilIcon className="h-8 w-8" data-id="element-13136" data-mp="svcz0scokzmo" />} vendorType="editors" filterSections={filterSections} opportunities={opportunities} opportunitiesLink="/services/editing/opportunities" formContent={formContent} formCTALabel="Submit an Editing Request" formCTADescription="Can't find the right editor? Submit your manuscript details and we'll match you." data-id="element-13135" data-mp="17jd48zjxuumt" />;
};
export default ConnectWithEditors;